export const CLEAR_CONVERSATION_ATTRIBUTES = 'CLEAR_CONVERSATION_ATTRIBUTES';
export const SET_CONVERSATION_ATTRIBUTES = 'SET_CONVERSATION_ATTRIBUTES';
export const SET_WIDGET_APP_CONFIG = 'SET_WIDGET_APP_CONFIG';
export const SET_WIDGET_COLOR = 'SET_WIDGET_COLOR';
export const UPDATE_CONVERSATION_ATTRIBUTES = 'UPDATE_CONVERSATION_ATTRIBUTES';
export const TOGGLE_WIDGET_OPEN = 'TOGGLE_WIDGET_OPEN';
export const SET_REFERRER_HOST = 'SET_REFERRER_HOST';
export const SET_BUBBLE_VISIBILITY = 'SET_BUBBLE_VISIBILITY';
export const SET_TIMERS_PARAMS = 'SET_TIMERS_PARAMS';
export const SET_PRECHAT_HIDDEN_FIELDS = 'SET_PRECHAT_HIDDEN_FIELDS';
export const SET_IS_SHOW_TRANSCRIPT_BUTTON = 'SET_IS_SHOW_TRANSCRIPT_BUTTON';
export const SET_IS_SHOW_FILE_TRANSFER_BUTTON = 'SET_IS_SHOW_FILE_TRANSFER_BUTTON';
export const SET_IS_CHAT_OFFLINE = 'SET_IS_CHAT_OFFLINE';
